import {
  Outlet,
  createFileRoute,
  redirect,
  retainSearchParams,
  stripSearchParams,
  useMatch,
} from '@tanstack/react-router'

import StudentAppPagePadding from '@/app/student/StudentAppPagePadding'
import { FEATURE_DISCOVER_ADVANCED_FILTERS } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { getPagePadding } from '@/core/utils/getPagePadding'
import { DiscoverAllSwitch } from '@/discover/components/DiscoverAllSwitch/DiscoverAllSwitch'
import { DiscoverCategoriesHeader } from '@/discover/components/DiscoverCategories/DiscoverCategoriesHeader'
import DiscoverSearchBar from '@/discover/components/DiscoverSearchBar/DiscoverSearchBar'
import {
  DEFAULT_DISCOVER_CHANNELS_SEARCH,
  discoverChannelsSearchParamKeys,
  discoverChannelsSearchSchema,
  hasDiscoverChannelsFilterSearch,
} from '@/discover/utils/discoverChannelsSearchSchema'

export const Route = createFileRoute('/_learning/discover/channels')({
  beforeLoad: ({ context, location, search }) => {
    if (context.user?.features.includes(FEATURE_DISCOVER_ADVANCED_FILTERS)) {
      return
    }

    if (!hasDiscoverChannelsFilterSearch(search)) {
      return
    }

    throw redirect({
      replace: true,
      search: {},
      to: location.pathname,
    })
  },
  validateSearch: discoverChannelsSearchSchema,
  search: {
    middlewares: [
      stripSearchParams(DEFAULT_DISCOVER_CHANNELS_SEARCH),
      retainSearchParams([...discoverChannelsSearchParamKeys]),
    ],
  },
  component: RouteComponent,
})

function RouteComponent() {
  const hasAdvancedFiltersFeature = useFeatures(
    FEATURE_DISCOVER_ADVANCED_FILTERS,
  )
  const search = Route.useSearch()
  const channelMatch = useMatch({
    from: '/_learning/discover/channels/$channel',
    shouldThrow: false,
  })
  const channelSlug = channelMatch?.params.channel

  return (
    <StudentAppPagePadding {...getPagePadding()} maxW="unset">
      <div data-testid="discover-search-bar-search-field">
        <DiscoverSearchBar
          query={hasAdvancedFiltersFeature ? search.query : undefined}
        />
      </div>
      {hasAdvancedFiltersFeature ? (
        <DiscoverCategoriesHeader />
      ) : (
        <DiscoverAllSwitch
          isPaddingApplied
          highlightDefault
          channelSlug={channelSlug}
        />
      )}
      <Outlet />
    </StudentAppPagePadding>
  )
}
